import { HttpClient, HttpParams } from '@angular/common/http';
import { MessageService } from 'primeng/primeng';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { Acm } from '../../models/loyalty-acm.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { AuthService } from '../user/auth.service';

@Injectable()
export class LoyaltyAcmService {

  private cache = new Map<string, Acm>();
  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;
  private cachedFieldsLayout: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService,
    private authService: AuthService,
    private httpClient: HttpClient
  ) { }

  get(acmId): Observable<Acm> {
    if (this.cache.has(acmId)) {
      return Observable.of(this.cache.get(acmId));
    }

    return this.http.get(this.baseUrl + '/acm/' + acmId).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }
  getAcmFromParams(search): Observable<Array<Acm>> {
    //metodo generale con parametri, usato nella stampa del modulo di trasferimento punti
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    return this.http.get(this.baseUrl + '/acm?' + params.toString()).map(res => {
      return res;
    });
  }
  list(
    offset = 0,
    limit = 99999,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number,
    by_status_valid?: string,
    by_flg_state?: string,
    by_flg_visible?: string
  ): Observable<{ data: Array<Acm>, metadata: ListMetadata }> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    if (offset !== null) {
      params.set('offset', offset.toString());
    }

    if (limit !== null) {
      params.set('limit', limit.toString());
    }

    if (sort) {
      params.set('sort', sort);
    }

    if (sort_dir) {
      params.set('sort_dir', sort_dir.toString());
    }

    if (by_status_valid) {
      params.set('status_valid', by_status_valid);
    }

    if (by_flg_state) {
      params.set('flg_state', by_flg_state);
    }

    if (by_flg_visible) {
      params.set('acmVisible', by_flg_visible);
    }
    // return this.http.get(this.baseUrl + '/acm/getAcmList?' + params.toString());
    return this.http.getPaged(this.baseUrl + '/acm/getAcmList?' + params.toString());
  }

  getKloyAccumulators(searchParams: Array<{ key: string, value: string }>) {
    let params: HttpParams = new HttpParams();
    for (const filter of searchParams) {
      params = params.set(filter.key, filter.value);
    }
    return this.http.getPaged('/koncentro-api/internal/getAcmList', params.toString());
  }

  getCustomerAccumulators(search?: Array<{ key: string, value: string }>): Observable<{ data: Array<Acm>, metadata: ListMetadata }> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        if (filter.key == "customerId" || filter.key == "customerHostId" || filter.key == "cardNo")
          params.set(filter.key, filter.value);
      }
    }
    return this.http.getPaged(this.baseUrl + '/loyalty/getAccumulators?' + params.toString());
  }

  update(acm: Acm): Observable<Acm> {
    let idAcm = acm.id;
    delete acm.id;
    return this.http.put(this.baseUrl + '/acm/' + idAcm, acm).map(res => {
      this.cache.delete(acm.id);
      return res;
    });
  }

  create(acm: any): Observable<Acm> {
    return this.http.post(this.baseUrl + '/acm/', acm);
  }

  remove(acmId): Observable<Acm> {
    return this.http.delete(this.baseUrl + '/acm/' + acmId).map(res => {
      this.cache.delete(acmId);
      this.srvNotify.add({ severity: 'info', summary: 'Success', detail: 'Operation success' });
      return res;
    });
  }
  recover(acm) {
    return this.http.put(this.baseUrl + "/acm/recover/" + acm.id, acm)
      .map(res => {
        this.cache.delete(acm.id);
        this.srvNotify.add({ severity: 'info', summary: 'Success', detail: 'Operation success' });
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/AcmDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getFieldsLayout() {
    if (!this.cachedFieldsLayout) {
      this.cachedFieldsLayout = this.http.get(`${this.baseUrl}/schema/AcmLayoutDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFieldsLayout;
  }

  getAllAcm(searchParams?: Array<{ key: string, value: string }>) {
    let params: HttpParams = new HttpParams();
    if (searchParams) {
      for (const filter of searchParams) {
        params = params.set(filter.key, filter.value);
      }
    }
    return this.http.get(this.baseUrl + '/acm/getAcmList', params.toString());
  }
  //KS-7228:escludere i bruciati
getAllAcmNoBurned(searchParams?: Array<{ key: string, value: string }>) {
  let params: HttpParams = new HttpParams();

  if (searchParams) {
    for (const filter of searchParams) {
      params = params.set(filter.key, filter.value);
    }
  }

  const url = `${this.baseUrl}/acm/getAcmList?excludeBurned=true`;
  return this.http.get(url, { params });
}



  getAcmListMulti(searchParams?: ({ value: string; key: string } | { value: number; key: string } | {
    value: string;
    key: string
  } | { value: string; key: string })[]) {
    let params: HttpParams = new HttpParams();
    if (searchParams) {
      for (const filter of searchParams) {
        params = params.set(filter.key, <string>filter.value);
      }
    }
    return this.http.get(this.baseUrl + '/acm/getAcmListMulti', params.toString());
  }
  //KS-7234
  getAcmListFromBalance(searchParams?: ({ value: string; key: string } | { value: number; key: string } | {
    value: string;
    key: string
  } | { value: string; key: string })[]) {
    let params: HttpParams = new HttpParams();
    if (searchParams) {
      for (const filter of searchParams) {
        params = params.set(filter.key, <string>filter.value);
      }
    }
    return this.http.get(this.baseUrl + '/acm/getAcmListFromBalance', params.toString());
  }

  //TODO capire quale parametro è.
  checkIfMultipleChannel() {
    let params: HttpParams = new HttpParams();

    return this.http.get(this.baseUrl + '/params/getParam/MULTI.CHANNEL.ACM', params.toString());
  }


  getExcelFilename(customerId: number, filters?: any[]): Observable<any> {
    let queryString = `customerId=${customerId}`;

    if (Array.isArray(filters) && filters.length > 0) {
      filters.forEach(filter => queryString += `&${filter.key}=${filter.value}`);
    }

    const userCompany = this.authService.user.selectedCompany.toString();
    const token = `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;

    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };

    return this.httpClient.get(
      `${this.baseUrl}/movement/exportMovements?${queryString}`,
      {
        headers: requestHeaders
      }
    );
  }




  downloadExcel(filename: string): Observable<Blob> {
    const requestBody = { 'filename': filename };
    const userCompany = this.authService.user.selectedCompany.toString();
    const token = `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };

    return this.httpClient.post(
      '/koncentro-customers/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    );
  }

}




// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-acm.service.ts